// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"c9f6ed88","120":"dd190a9f","213":"cdb5020b","611":"8e1f7c59","667":"44c9a9cf","942":"86c4415b"}[chunkId] + ".chunk.js";
};